import axios from 'axios-jsonp-pro';
import qs from 'qs';

const get = async url => {
  return await axios.get(url);
};
const post = async (url, params = {}) => {
  return await axios.post(url, qs.stringify(params), {
    withCredentials: true,
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  });
};
const getQuery = async (url, params = {}) => {
  let requestUrl = `https://query.aliyun.com/rest/${url}`;
  if (params) {
    requestUrl = `https://query.aliyun.com/rest/${url}?${qs.stringify(params)}`;
  }
  const result = await get(requestUrl);
  return result.data;
};
const jsonp = async (url, params = {}) => {
  return await axios.jsonp(url, {
    params,
  });
};

export { get, post, getQuery, jsonp };



// WEBPACK FOOTER //
// ./src/util/request.js